import type { UserManagerSettings } from 'oidc-client-ts';

const scopes: { [key: string]: string } = {
  'production': `email api://ed822f1e-3d1b-404f-890c-d579075a3972/closing-dashboard-gbs(PROD)`,
  'quality': `openid profile email api://2e022329-de34-4924-b7fd-2807135e087e/closing-dashboard-gbs(DEV)`,
  'development': `openid profile email api://ed822f1e-3d1b-404f-890c-d579075a3972/closing-dashboard-gbs(PROD)`
}
const oidcConfig: UserManagerSettings = {
  authority: import.meta.env.VITE_SSO_AUTHORITY,
  client_id: import.meta.env.VITE_SSO_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_SSO_REDIRECT_URI,
  post_logout_redirect_uri: import.meta.env.VITE_SSO_POST_LOGOUT_REDIRECT_URI,
  response_type: 'code',
  scope: scopes[import.meta.env.MODE]
  //scope: `openid profile email`
  //scope: `openid profile email api://2e022329-de34-4924-b7fd-2807135e087e/closing-dashboard-gbs(DEV)`,
  //scope: `openid profile email api://ed822f1e-3d1b-404f-890c-d579075a3972/closing-dashboard-gbs(PROD)`
};


export default oidcConfig;